import { ComponentProps, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { FormRow, Text } from '@frontend/design-system';

type AvailabilityRuleFormRowProps = ComponentProps<typeof FormRow> & { title?: string };

export const AvailabilityRuleFormRow = ({
  children,
  title,
  ...props
}: PropsWithChildren<AvailabilityRuleFormRowProps>) => {
  return (
    <>
      {title && (
        <div css={styles.formRowWithTitle}>
          <Text weight='bold' color='subdued' css={labelStyle}>
            {title}
          </Text>
        </div>
      )}
      <FormRow {...props} css={styles.formRow}>
        {children}
      </FormRow>
    </>
  );
};

const labelStyle = css`
  font-weight: ${theme.font.weight.bold};
  color: ${theme.font.colors.subdued};
  margin-bottom: ${theme.spacing(1)};
`;

const styles = {
  formRowWithTitle: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
  `,
  formRow: css`
    label:not([class*='InlineLabel']) {
      ${labelStyle}
    }
  `,
};
